import React, { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import type { Note } from "../../../hooks/useNotes";

interface NotesTabProps {
  notes: Note[];
  notesLoading: boolean;
  newNote: string;
  setNewNote: (note: string) => void;
  onAddNote: () => void;
  isCreatingNote: boolean;
}

const NotesTab: React.FC<NotesTabProps> = ({
  notes,
  notesLoading,
  newNote,
  setNewNote,
  onAddNote,
  isCreatingNote,
}) => {
  const { t } = useTranslation(["recruiting", "common"]);

  return (
    <div className="notes-tab">
      <div className="notes-header">
        <h3>{t("candidates.detail.notes")}</h3>
      </div>

      <div className="add-note-section">
        <textarea
          value={newNote}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setNewNote(e.target.value)
          }
          placeholder={t("candidates.detail.addNotePlaceholder")}
          className="note-textarea"
          rows={3}
        />
        <button
          onClick={onAddNote}
          disabled={!newNote.trim() || isCreatingNote}
          className="btn-primary"
        >
          {isCreatingNote
            ? t("common:loading.adding")
            : t("candidates.detail.addNote")}
        </button>
      </div>

      {notesLoading && (
        <div className="loading-state">
          <div className="spinner"></div>
          <p>{t("common:loading.notes")}</p>
        </div>
      )}
      {!notesLoading && notes.length === 0 && (
        <div className="empty-state">
          <p>{t("candidates.detail.noNotesYet")}</p>
        </div>
      )}
      {!notesLoading && notes.length > 0 && (
        <div className="notes-list">
          {notes.map((note) => (
            <div key={note.id} className="note-item">
              <div className="note-header">
                <span className="note-author">{note.author_name}</span>
                <span className="note-date">
                  {new Date(note.created_at).toLocaleDateString()}
                </span>
              </div>
              <div className="note-content">{note.content}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotesTab;
